import ConfirmationSlide from './ConfirmationSlide';

export default ConfirmationSlide;
